function geral(){
	return {
			"games":[
				{
					"informs":[
						{
							"text":"A doença COVID-19 é transmitida através do contato com o vírus causador dessa infecção. Isso ocorre, principalmente, de uma pessoa contaminada para uma pessoa saudável. ",
							"title":"Informações gerais sobre a doença",
							"image":"/images/games/informs/geral/1.png",
						},
						{
							"text":"Lavar as mãos, utilizar a máscara e manter o distanciamento social são medidas importantes para evitar a propagação da COVID-19.",
							"title":"Informações gerais sobre a doença",
							"image":"/images/games/informs/geral/1.png",
						},
						{
							"text":"Se esteve em contato com um indivíduo contaminado, fique isolado por 14 dias e use máscaras o tempo todo.",
							"title":"Informações gerais sobre a doença",
							"image":"/images/games/informs/geral/1.png",
						},
						{
							"text":"Preste atenção se tiver sintomas parecidos com os da gripe e, caso piore, procure um serviço médico.",
							"title":"Informações gerais sobre a doença",
							"image":"/images/games/informs/geral/1.png",
						}
					],
					"pathImageGame":"midias/images/games/puzzles/geral/1.png"
				}
			]
		};
}

export {geral};
